import {
	primaryColor,
	primaryBoxShadow,
	whiteColor,
	defaultBodyFont,
	blackColors,
	hexToRgb,
} from 'assets/jss/material-dashboard-pro-react';
import { darken } from '@material-ui/core/styles';

const dropdownStyle = () => ({
	selectMenuItem: {
		fontSize: '14px',
		padding: '12px 16px 12px 8px',
		margin: '0 20px 0 8px',
		borderRadius: '4px',
		transition: 'all 150ms linear',
		display: 'block',
		clear: 'both',
		fontWeight: 'normal',
		lineHeight: '16px',
		minHeight: '40px',
		whiteSpace: 'nowrap',
		paddingRight: '30px',
		...defaultBodyFont,
		letterSpacing: '0.2px !important',
		color: blackColors[1],
		'&:hover': {
			backgroundColor: primaryColor[0],
			color: whiteColor + ' !important',
			...primaryBoxShadow,
		},
		'&.Mui-disabled': {
			opacity: 1,
			color: blackColors[3],
		},
	},
	dropdown: {
		'& .MuiPaper-root': {
			borderRadius: 4,
			minWidth: 168,
			'& .MuiList-root': {
				padding: '8px 0',
				'& .MuiButtonBase-root': {
					padding: '11px 8px',
					borderRadius: 0,
					margin: '0 5px',
					boxShadow: 'none',
					display: 'flex',
					'&:hover': {
						backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.2)`,
						color: 'inherit',
					},
					'&:active': {
						backgroundColor: darken(primaryColor[0], 0.12),
						'& p': {
							color: whiteColor + ' !important',
						},
					},
					'& p': {
						transition: 'all 150ms linear',
					},
				},
			},
		},
	},
});

export default dropdownStyle;
